import styled from 'styled-components'

export const CenteredSection = styled.span`
  text-align: center;
`

export default CenteredSection



// WEBPACK FOOTER //
// ./src/components/common/layout/index.js